import styled from 'styled-components'
import COLORS from '@colors'

export const Header = styled.div`
  box-shadow: 0 4px 8px #00000012;
  display: flex;
  z-index: 5;
  font-family: 'Barlow';
  font-size: 14px;
  height: 64px;
  overflow-y: visible;
  left: 0;
  padding: 0 24px;
  position: fixed;
  right: 0;
  top: 0;
`

export const LogoWrapper = styled.div`
  padding: 22px 0;
  width: 131px;
`

export const Nav = styled.nav`
  display: flex;
  color: ${COLORS.whiteA1};
  width: calc(100% - 289px);
`

export const Item = styled.div`
  color: ${props => (props.active ? COLORS.gray45 : COLORS.whiteA1)};
  height: 64px;
  margin: 0 12px;
  padding: 26px 0 24px 0;
  cursor: pointer;
  user-select: none;
  ${props =>
    props.active &&
    `border-top: 4px solid ${COLORS.leather}; padding-top: 22px;`}

  a {
    text-decoration: none;
    color: inherit;
  }
`

export const UserActions = styled.div`
  align-items: center;
  color: ${COLORS.gray45};
  display: flex;
  width: 154px;
`
export const UserName = styled.div`
  max-width: 80px;
  margin-right: 10px;
  text-align: right;
`

export const DropDownMenu = styled.div`
  display: inline-block;
  position: relative;
  top: -3px;
`
